import React from 'react'

import IProps from './interface'

const ResultsCount = (props: IProps) => {
  const { totalItems, pageSize, currentPage, contentType, isLoadMore = false, loadedItems = 0 } = props

   // Calculate range differently based on pagination style
  const calculateRange = () => {
    // For load more, use the actual number of loaded items
    if (isLoadMore && loadedItems > 0) {
      const startIndex = 1
      const endIndex = Math.min(loadedItems, totalItems)
      return { startIndex, endIndex }
    } 
    
    // For standard pagination, calculate based on page number and size
    const startIndex = (currentPage - 1) * pageSize + 1
    const endIndex = Math.min(currentPage * pageSize, totalItems)
    return { startIndex, endIndex }
  }

  const { startIndex, endIndex } = calculateRange()

  // Because on "Find a course" (displaying only `contentType=course`) we "load more", startIndex is always 1. BA 2024-08-13
  /* const startIndex =
    contentType === 'course' ? 1 : (currentPage - 1) * pageSize + 1
  const endIndex =
    pageSize * currentPage >= totalItems ? totalItems : pageSize * currentPage */

  return (
    <div className='resultsCount' aria-labelledby='results-count'>
      <p id='results-count'>
        {totalItems > 0 ? (
          <>
            <span className='resultsCount__bold'>
              {startIndex.toLocaleString()} - {endIndex.toLocaleString()}
            </span>{' '}
            of{' '}
            <span className='resultsCount__bold'>
              {totalItems.toLocaleString()}
            </span>{' '}
            {contentType} results
          </>
        ) : (
          <>
            Your search returned{' '}
            <span className='resultsCount__bold'>{totalItems} results</span>
          </>
        )}
      </p>
    </div>
  )
}

export default ResultsCount
